module.exports = __webpack_public_path__ + "img/calculator-card-pictures-5.b8cca3ab.jpg";